import { CombinedGraphQLErrors, type ErrorLike } from '@apollo/client';

/** Request id and field path of a query's first GraphQL error, for display. */
export const getGraphQLErrorDetails = (error: ErrorLike | undefined) => {
  const [firstError] = CombinedGraphQLErrors.is(error) ? error.errors : [];
  const requestId = firstError?.extensions?.requestId;
  return {
    errorRequestId: typeof requestId === 'string' ? requestId : undefined,
    errorPath: firstError?.path?.join(' > '),
  };
};
